import { IPricingTableHeader } from '../interfaces/IPricingTableHeader';

const PRICING_PAGE_TABLE_HEADER: IPricingTableHeader[] = [
  {},
  {},
  {
    id: 1,
    name: 'PAY AS YOU GO',
    description: 'Start with measurements and access to basic features.',
    buttonText: 'Start free trial',
    background: 'brandBrown.100',
    type: 'The Basics',
  },
  {
    id: 2,
    name: 'MEASURE',
    description:
      'For individuals and small businesses who want to integrate their workflows.',
    buttonText: 'Contact sales',
    linkTo:
      'https://calendly.com/hover-sdr/hover-membership-website?/utm_source=measure',
    background: 'brandTan.200',
    type: 'Premium',
  },
  {
    id: 3,
    name: 'SCALE',
    description:
      'For businesses who need access to advanced features that accommodate larger job volumes.',
    buttonText: 'Contact sales',
    linkTo:
      'https://calendly.com/hover-sdr/hover-membership-website?/utm_source=scale',
    background: 'brandGreen.100',
    type: 'Premium',
  },
  {
    id: 4,
    name: 'TRANSFORM',
    description:
      'For businesses looking to power their end to end workflow from sales to production.',
    buttonText: 'Contact sales',
    linkTo:
      'https://calendly.com/hover-sdr/hover-membership-website?/utm_source=transform',
    background: 'primary.100',
    type: 'Premium',
  },
];

export default PRICING_PAGE_TABLE_HEADER;
